import { type Enum } from '@webapp/infrastructure/types/Enum'

export const AddressTypes = {
  BILLING: 'BILLING',
  SHIPPING: 'SHIPPING',
  VENDOR: 'VENDOR',
  GENERAL: 'GENERAL',
  USER: 'USER',
  TRAVEL: 'TRAVEL',
  PRIVATE: 'PRIVATE',
} as const

export type AddressTypeEnum = Enum<typeof AddressTypes>
